import React, { useEffect, useState } from 'react';
import moment from 'moment-timezone';
import { Controller, useFormContext } from 'react-hook-form';
import { FormControl } from '@material-ui/core';

import { RestrictedDatePicker } from '../../../../custom-widgets';

// This component uses the old date picker
// Use DateSelector for updated date picker
export default function DatePicker({ name, props: { label, variant, disabled, range, ...rest }, referenceFieldMin, referenceFieldMax, isEdit }) {
    const [error, setError] = useState(null);

    const {
        control,
        formState: { errors, touchedFields },
        getValues,
        selectedDate,
        setValue,
    } = useFormContext();

    let minDate = referenceFieldMin && getValues(referenceFieldMin) ? moment(getValues(referenceFieldMin)) : undefined;
    let maxDate = referenceFieldMax && getValues(referenceFieldMax) ? moment(getValues(referenceFieldMax)) : undefined;
    if (range) {
        minDate = moment(selectedDate).startOf(range.startOf);
        maxDate = moment(selectedDate).endOf(range.endOf);
    }

    useEffect(() => {
        const touched = touchedFields[name];
        // If no default values from edit and field is not touched, set the default value
        if (!isEdit && !touched) {
            setValue(name, moment(selectedDate));
        }
    }, [selectedDate]);

    useEffect(() => {
        setError(errors[name]);
    }, [errors]);

    return (
        <FormControl fullWidth style={{ margin: '8px 0' }}>
            <Controller
                control={control}
                name={name}
                render={({ field: { onChange, value } }) => (
                    <RestrictedDatePicker
                        onChange={onChange}
                        label={label}
                        inputVariant={variant || 'standard'}
                        value={value}
                        disabled={disabled}
                        error={!!error}
                        helperText={error?.message}
                        minDate={minDate}
                        maxDate={maxDate}
                        {...rest}
                        // wrap
                    />
                )}
            />
        </FormControl>
    );
}
